// Hero for the /use-cases index — eyebrow + title.
//
// Mirrors the /blog index hero exactly (gradient background, hairline-then-
// small-caps eyebrow, padding, outer container) so navigating between Blog
// and Use cases doesn't visually jump. The H1 width is intentionally wider
// here — the catalogue title benefits from the extra horizontal room.
export function UseCasesIndexHero() {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(180deg,#FAFAFF_0%,#FFFFFF_100%)] px-[clamp(24px,5vw,80px)] pt-[clamp(56px,7vw,96px)] pb-[clamp(32px,4vw,56px)]">
      <div className="relative mx-auto max-w-[1180px]">
        <div className="mb-5 flex items-center gap-3">
          <div className="h-px w-8 bg-indigo-300" />
          <div className="font-body text-xs font-semibold uppercase tracking-[0.14em] text-indigo-700">
            Use cases
          </div>
        </div>
        <h1 className="font-companion m-0 text-[clamp(40px,5.5vw,64px)] font-bold leading-[1.05] tracking-[-0.03em] text-primary [text-wrap:balance]">
          See how vets use Companion in real workflows.
        </h1>
      </div>
    </section>
  );
}
